<template>
    <DataTable
        class="card"
        :header="$t('logs')"
        :items="items"
        :fields="fields"
        :loading="loading"
        :error="error"
        :total-rows="logs.max"
    >

        <template #cell(description)="{item}">
            <div v-if="item.description" class="d-flex gap-2">
                <TruncatedTextModal :text="item.description" :button-title="$t('showWholeDescription')" :modal-title="$t('description')" />
            </div>
        </template>

        <template #cell(images)="{item}">
            <div class="d-flex gap-2 flex-wrap">
                <ImageLoader
                    v-for="(image, key) in item.images"
                    :key="key"
                    :src="image"
                    alt=""
                    size="30"
                    image-height="auto"
                    class="flex-shrink-0"
                    preview
                />
            </div>
        </template>

    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import TruncatedTextModal from '@/components/common/TruncatedTextModal.vue';

    export default {
        name: 'Logs',
        components: {
            DataTable,
            ImageLoader,
            TruncatedTextModal,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestLogs,
                id: this.parentComponent.id,
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'timestamp', label: this.$t('timestamp'), formatter: value => value && this.$format.datetime(value) },
                    { key: 'sku', label: this.$t('sku'), tdClass: 'nowrap' },
                    { key: 'productId', label: this.$t('aggregateId') },
                    { key: 'catalogId', label: this.$t('productId') },
                    { key: 'ean', label: this.$t('ean') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'images', label: this.$t('images') },
                    { key: 'description', label: this.$t('description') },
                    { key: 'createdAt', label: this.$t('createdAt'), formatter: value => value && this.$format.datetime(value) },
                    { key: 'updatedAt', label: this.$t('updatedAt'), formatter: value => value && this.$format.datetime(value) },
                    { key: 'space', label: this.$t('space') },
                    { key: 'price', label: this.$t('price'), formatter: value => (Number.isFinite(Number.parseInt(value)) ? this.$format.currency(value) : ''), tdClass: 'nowrap' },
                ];
            },
            loading() {
                return this.request.getLoading();
            },
            error() {
                return this.request.getError();
            },
            logs() {
                return this.request.getData() || {};
            },
            items() {
                return this.logs?.items || [];
            },
        },
        methods: {
            fetchLogs() {
                return this.request.get({ urlParams: { id: this.id } }).catch(() => {});
            },
        },
        created() {
            this.fetchLogs();
        },
    };
</script>
